import styled from 'styled-components'
import theme from '../../../../styles/theme'
import { media } from '../../../../styles/utils'

export const Wrapper = styled.div`
  display: block;
  width: 100%;
  text-align: center;
  padding: 0 16px;
  margin-bottom: -1px;
  margin-bottom: 27px;

  ${media.sm`
    text-align: left;
    padding: 0 8px;
  `};
`

export const Text = styled.p`
  font-family: ${theme.brandFontFamily};
  font-size: ${theme.headingCheckout};
  margin: 0;
`
